import { render, staticRenderFns } from "./CreateWallet.vue?vue&type=template&id=7b82bfea&scoped=true&"
import script from "./CreateWallet.vue?vue&type=script&lang=js&"
export * from "./CreateWallet.vue?vue&type=script&lang=js&"
import style0 from "./CreateWallet.vue?vue&type=style&index=0&id=7b82bfea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82bfea",
  null
  
)

export default component.exports